import{styled as t}from"@mui/material/styles";const e=t("div")((({theme:t,$gap:e})=>({height:`${e}px`,[t.breakpoints.down("md")]:{height:e/2+"px"}})));export{e as SpacerWrapperDiv};
//# sourceMappingURL=styles.js.map
